import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsFeatures({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.8 9.454a.75.75 0 01.743.648l.007.102v3a.75.75 0 01-1.493.102l-.007-.102v-1.088A6.75 6.75 0 017.7 14.75a.75.75 0 110-1.5 5.254 5.254 0 004.34-2.296H10.8a.75.75 0 01-.743-.648l-.007-.102a.75.75 0 01.648-.743l.102-.007h3zM4.3 7.35a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm0 1.5a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm7.4-6.7a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm0 1.5a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm-3.4-2.4a.75.75 0 010 1.5 5.254 5.254 0 00-4.346 2.303H5.2a.75.75 0 01.743.65l.007.1a.75.75 0 01-.648.744l-.102.007h-3a.75.75 0 01-.743-.648l-.007-.102v-3a.75.75 0 011.493-.102l.007.102-.002 1.082A6.75 6.75 0 018.3 1.25z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsFeatures.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsFeatures.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsFeatures svgRef={ref} {...props} />
));
export default ForwardRef;
